export default {
  TableHeadMEMBER: [
    [
      {
        displayName: 'suggest.member.datatable.number',
      },
      {
        displayName: 'suggest.member.datatable.username',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'suggest.member.datatable.comment',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'suggest.member.datatable.cate',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'suggest.member.datatable.topic',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'suggest.member.datatable.mobile',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'suggest.member.datatable.time',
      },
    ],
  ],
};
